import { Tooltip } from '@mantine/core';
import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import { IconStrikethrough } from '@tabler/icons-react';

/**
 * Used to strikethrough text.
 */
export default function ControlStrikethrough() {
  const { editor } = useRichTextEditorContext();
  return (
    <Tooltip label="Strikethrough" openDelay={300} closeDelay={50} withArrow={false}>
      <RichTextEditor.Control
        onClick={() => editor?.chain().focus().toggleStrike().run()}
        active={editor?.isActive('strike')}
      >
        <IconStrikethrough size={20} />
      </RichTextEditor.Control>
    </Tooltip>
  );
}
